// extracted by mini-css-extract-plugin
export default {"ToggleContainer":"_ToggleContainer--HQtwI","ToggleSwitch":"_ToggleSwitch--q33qM","ToggleLabel":"_ToggleLabel--NWy_R","AiImportLabel":"_AiImportLabel--IM1BC"};